import { render, staticRenderFns } from "./ListAlbums.vue?vue&type=template&id=1aa1fde3&scoped=true&"
import script from "./ListAlbums.vue?vue&type=script&lang=js&"
export * from "./ListAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1fde3",
  null
  
)

export default component.exports